import { render, staticRenderFns } from "./DatabaseSelector.vue?vue&type=template&id=1127526f&scoped=true"
import script from "./DatabaseSelector.vue?vue&type=script&lang=ts"
export * from "./DatabaseSelector.vue?vue&type=script&lang=ts"
import style0 from "./DatabaseSelector.vue?vue&type=style&index=0&id=1127526f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1127526f",
  null
  
)

export default component.exports